import {Product} from './product';

export class QuestionDetails {
 id: string;
 price: number;
 questionId: string;
 answerId: string;
}

export class ArticleLine {
  generatedId: string;
  price: number;
  quantity: number;
  product: Product;
  questionDetails: {[questionId: string]: QuestionDetails};
}
